import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const BubbleRoundOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.8 19.406V15.2486C9.91648 15.1384 6.85796 15.0629 4.32628 13.5022C2.7539 12.5329 1.8 11.1411 1.8 9C1.8 6.74793 2.85819 5.30458 4.62416 4.32348C6.4983 3.28229 9.15167 2.8 12 2.8C14.8483 2.8 17.5017 3.28229 19.3758 4.32348C21.1418 5.30458 22.2 6.74793 22.2 9C22.2 11.1469 20.5812 13.3238 17.8664 15.621C16.2557 16.984 14.5196 18.1867 12.8 19.406ZM11 23V16.9811C5.3512 16.7652 0 14.6663 0 9C0 3 6 1 12 1C18 1 24 3 24 9C24 15.0516 15.0777 19.6019 11 23ZM7 8.1001V9.9001H17V8.1001H7Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const BubbleRoundOutlinedSize24 = hoc(forwardRef(BubbleRoundOutlinedSize24Component), 'BubbleRoundOutlinedSize24');

export { BubbleRoundOutlinedSize24 as default };
//# sourceMappingURL=BubbleRoundOutlinedSize24.js.map
